import React, { useEffect } from 'react';
import { Typography, Row, Col, Card, Form, Input, Button, message } from 'antd';
import { MailOutlined, PhoneOutlined, HomeOutlined, UserOutlined } from '@ant-design/icons';
import PageLayout from '../../components/layout/Layout';
import './index.css';
import AppHeader from '../../components/Header';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const ContactPage = () => {
  const [form] = Form.useForm();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const handleSubmit = (values) => {
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', values);
    message.success('Thank you for your message. We will get back to you soon!');
    form.resetFields();
  };

  return (
    <>
      <AppHeader />
      <div className="contact-container" style={{paddingTop: 72}}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Title level={2}>Contact Us</Title>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            <Card className="contact-form-card">
              <Title level={3}>Send us a Message</Title>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
              >
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[{ required: true, message: 'Please enter your name' }]}
                    >
                      <Input prefix={<UserOutlined />} placeholder="Your name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        { required: true, message: 'Please enter your email' },
                        { type: 'email', message: 'Please enter a valid email' }
                      ]}
                    >
                      <Input prefix={<MailOutlined />} placeholder="Your email" />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name="subject"
                  label="Subject"
                  rules={[{ required: true, message: 'Please enter a subject' }]}
                >
                  <Input placeholder="Message subject" />
                </Form.Item>

                <Form.Item
                  name="message"
                  label="Message"
                  rules={[{ required: true, message: 'Please enter your message' }]}
                >
                  <TextArea rows={6} placeholder="Your message" />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" size="large">
                    Send Message
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card className="contact-info-card">
              <Title level={3}>Contact Information</Title>
              <div className="contact-info-item">
                <MailOutlined /> contact@example.com
              </div>
              <div className="contact-info-item">
                <PhoneOutlined /> +1 (555) 123-4567
              </div>
              <div className="contact-info-item">
                <HomeOutlined /> 123 Business Street<br />
                  Suite 100 California 12345
             
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ContactPage; 